<template>
  <div class="text-xs-center">
    <v-dialog v-model="show" max-width="400px">
      <v-card>
        <v-card-text>
          Вы уверены, что хотите отправить СМС всем клиентам?
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-layout align-center justify-end>
            <v-btn @click="show = false" color="#df2935" style="color:white" >НЕТ</v-btn>
            <v-btn @click="confirm" color="#4169E1" style="color:white">ДА</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  methods: {
    confirm: function () {
      this.$emit('confirmed')
      this.show = false
    }
  },
  props: {
    value: Boolean
  },
  computed: {
    show: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  }
}
</script>
